import { useEffect, useState } from "react";
import api, { apiErrorMessage } from "@/lib/api";
import ReportPanel from "@/components/ReportPanel";
import DensityMap from "@/components/DensityMap";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function ReportsPage() {
  const [records, setRecords] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get("/columns"), api.get("/records")])
      .then(([c, r]) => {
        setColumns(c.data);
        setRecords(r.data);
      })
      .catch((e) => toast.error(apiErrorMessage(e)))
      .finally(() => setLoading(false));
  }, []);

  if (loading)
    return (
      <div className="flex-1 flex items-center justify-center text-muted-foreground">
        <Loader2 className="w-6 h-6 animate-spin" />
      </div>
    );

  return (
    <div className="flex-1 overflow-auto grid-scroll p-4 md:p-6 space-y-6">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight">Raporlar</h1>
        <p className="text-sm text-muted-foreground">
          İl hedefleri, sonuç, aşama ve şube dağılımları — {records.length} kayıt üzerinden.
        </p>
      </div>
      <DensityMap records={records} />
      <ReportPanel records={records} columns={columns} />
    </div>
  );
}
